var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from 'react';
import { getProgress } from '../api/progress';
/**
 * Poll the server's progress registry while `active` for the given `id`. Returns the
 * latest snapshot, or null before the first successful poll. A 404 (the job hasn't
 * reported its first stage yet, or has expired) is swallowed — the caller falls back
 * to a plain spinner while progress is null.
 */
export function useJobProgress(id, active, intervalMs = 600) {
    const [progress, setProgress] = useState(null);
    useEffect(() => {
        if (!id || !active) {
            setProgress(null);
            return;
        }
        let cancelled = false;
        const tick = () => __awaiter(this, void 0, void 0, function* () {
            try {
                const p = yield getProgress(id);
                if (!cancelled)
                    setProgress(p);
            }
            catch ( /* 404 before the first stage / after expiry — keep the spinner */_a) { /* 404 before the first stage / after expiry — keep the spinner */ }
        });
        tick();
        const timer = setInterval(tick, intervalMs);
        return () => { cancelled = true; clearInterval(timer); };
    }, [id, active, intervalMs]);
    return progress;
}
